import { PATH_TEMPLATE, PATH_EXPORT_XLSX, ALL } from "@/const/batch";
export const getEmailReset = (state) => {
  return state.emailReset;
};

export const getTimerCountDown = (state) => {
  return state.timer;
};


export const isCheckALlTemplate = (state) => {
  const index = state.authUser?.menu_list.find((item) => item.path === PATH_TEMPLATE && item.action === ALL)
  if (index) {
    return true;
  }
  return false;
}

export const isCheckALlXlsx = (state) => {
  const index = state.authUser?.menu_list.find((item) => item.path === PATH_EXPORT_XLSX  && item.action === ALL)
  if (index) {
    return true;
  }
  return false;
}
